import React, { useEffect } from "react";
import "./style.scss";
import useFacility from "../../../utils/hooks/useFacility";
import { post } from "../../api";
import { CLEAR_BASKET_URL } from "../../api/apiRoutes";
import AccountActivatedDetails from "../HandlerModalByUrl/AccountActivated";
import { LOGIN_PAGE } from "../../routes";
import { useNavigate, useSearchParams } from "react-router-dom";
import useActivationUser from "../HandlerModalByUrl/hooks/useActivationUser";
import { useTranslation } from "react-i18next";
import EAButton from "../shared/Buttons/EAButton";

const AccountActivated: React.FC = () => {
  const { t } = useTranslation();
  const facilityIds = useFacility();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const url = window.location.href;

  const { activateUser } = useActivationUser();
  const handleClearBasket = async () => {
    await post(CLEAR_BASKET_URL(facilityIds));
  };

  // Funkcja do pobrania tokenu - obsługuje zarówno query params jak i URL path
  const getActivationToken = (): { token: string | null; facilityId: string | null } => {
    // Najpierw spróbuj pobrać z query params (iframe mode)
    const idParam = searchParams.get("id");
    if (idParam) {
      const [fId, token] = idParam.split("/");
      return { token, facilityId: fId };
    }

    // Fallback: pobierz z URL path (bezpośredni dostęp)
    const token = url.split("/").pop();
    return { token: token || null, facilityId: facilityIds?.substring(0, 4) || null };
  };

  useEffect(() => {
    if (Boolean(facilityIds)) {
      handleClearBasket();
    }

    const { token, facilityId } = getActivationToken();

    setTimeout(() => {
      if (token && facilityId) {
        activateUser(token, facilityId);
      }
    }, 200);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [facilityIds, searchParams]);

  return (
    <div className={"account-activated-wrapper"}>
      <div className={"account-activated-panel shadow"}>
        <h3 className={"account-activated-panel-title"}>{t("gratulacje_twoje_konto_jest_juz_aktywne")}</h3>
        {/* <p className={"account-activated-panel-section-1"}>{t("dziekujemy_za_zalozenie_konta")}</p> */}
        <AccountActivatedDetails />
        <div className="divider"></div>
        <div className={"div-buttons"} style={{ justifyContent: "center" }}>
          <EAButton title={t("swietnie_zaloguj_sie")} onClick={() => navigate(LOGIN_PAGE)} fullWidth />
        </div>
      </div>
    </div>
  );
};

export default AccountActivated;
